// Comprehensive English label map for all form_data keys used across the application.
// Used in ServiceRequestDetailPage, ProviderDashboardPage, ListingDetailPage etc.
// (Iter425: full UK English rewrite — was a Turkish/English hybrid.)

const FIELD_LABELS = {
  // === GENERAL ===
  work_type: 'Job Type',
  service_type: 'Service Type',
  problem_type: 'Issue Type',
  urgency: 'Urgency',
  property_type: 'Property Type',
  property_size: 'Area Size',
  timeline: 'Required Duration',
  frequency: 'Frequency',
  has_project: 'Has Project?',
  has_permit: 'Has Licence/Permit?',
  material_provided: 'Materials Supplied',
  material_included: 'Materials Included?',
  brand: 'Brand',
  model: 'Model',
  location: 'Location',
  notes: 'Notes',

  // === PLUMBING ===
  water_shutoff_available: 'Can the main water valve be turned off?',
  estimated_area: 'Estimated Area / Size',

  // === ELECTRICAL ===
  floor_count: 'Number of Floors',

  // === PAINTING ===
  paint_type: 'Paint Type',
  surface_area: 'Estimated Area (m²)',
  room_count: 'Number of Rooms',
  current_paint_condition: 'Current Wall Condition',
  paint_quality: 'Required Paint Quality',
  furniture_moving_needed: 'Furniture Move Needed?',

  // === CLEANING ===
  cleaning_type: 'Cleaning Type',
  supplies_included: 'Cleaning Supplies',
  pet_in_house: 'Pets at Home?',

  // === RENOVATION ===
  renovation_type: 'Renovation Type',
  permit_available: 'Has Licence/Permit?',

  // === CARPENTRY ===
  item_count: 'Quantity',
  has_measurements: 'Measurements Ready?',

  // === LOCKSMITH ===
  lock_type: 'Lock Type',
  is_locked_out: 'Locked Out?',

  // === AIR CONDITIONING ===
  ac_type: 'A/C Type',
  ac_count: 'Number of A/C Units',
  has_outdoor_unit_access: 'Easy Access to Outdoor Unit?',

  // === BOILER ===
  combi_type: 'Boiler Type',
  error_code: 'Fault Code',
  last_maintenance_date: 'Last Service Date',

  // === APPLIANCES ===
  appliance_type: 'Appliance Type',
  problem_description: 'Fault Symptom',
  warranty_status: 'Warranty Status',

  // === GARDENING ===
  garden_size: 'Garden Size (m²)',
  has_irrigation_system: 'Has Irrigation System?',
  tree_count: 'Number of Trees',

  // === PEST CONTROL ===
  pest_type: 'Pest Type',
  has_children_or_pets: 'Children/Pets at Home?',
  severity: 'Severity',

  // === ROOFING ===
  roof_type: 'Roof Type',
  roof_area: 'Roof Area (m²)',
  has_water_leak: 'Water Leak?',
  building_height: 'Number of Floors',

  // === PRIVATE TUITION ===
  subject: 'Subject',
  student_level: 'Student Level',
  lesson_frequency: 'Lesson Frequency',
  lesson_duration: 'Lesson Duration',
  lesson_location: 'Lesson Location',

  // === TRANSLATION ===
  source_language: 'Source Language',
  target_language: 'Target Language',
  document_type: 'Document Type',
  word_count: 'Word/Page Count',
  deadline: 'Delivery Date',

  // === HEALTHCARE ===
  patient_mobility: 'Patient Mobility',
  patient_age: 'Patient Age',
  special_equipment_needed: 'Special Equipment Needed?',

  // === BEAUTY ===
  location_preference: 'Service Location',
  gender_preference: 'Gender Preference',
  appointment_date: 'Appointment Date',

  // === PETS ===
  pet_type: 'Animal Type',
  pet_breed: 'Breed',
  pet_size: 'Size',
  has_vaccination: 'Vaccinations Up to Date?',

  // === CONSTRUCTION ===
  project_size: 'Project Size',

  // === MOTOR REPAIR ===
  vehicle_type: 'Vehicle Type',
  vehicle_brand: 'Vehicle Make',
  vehicle_model: 'Vehicle Model',
  vehicle_year: 'Vehicle Year',

  // === AGRICULTURE ===
  area_donum: 'Area (Acres)',
  area_donum_display: 'Area (Acres)',
  preferred_date: 'Preferred Date',
  location_detail: 'Location Details',
  with_operator: 'Operator Included?',
  duration_days: 'Duration (Days)',
  crop_type: 'Crop Type',

  // === HEAVY MACHINERY ===
  load_weight: 'Load Weight (Tonnes)',
  height_meters: 'Lift Height (m)',
  duration_hours: 'Duration (Hours)',
  depth_meters: 'Depth (m)',
  soil_type: 'Soil Type',
  material_type: 'Material Type',
  load_count: 'Number of Trips',
  distance_km: 'Distance (km)',

  // === REMOVALS / TRANSPORT ===
  cargo_type: 'Load Type',
  cargo_title: 'Load Title',
  cargo_description: 'Load Description',
  pickup_address: 'Pickup Address',
  delivery_address: 'Delivery Address',
  estimated_weight: 'Estimated Weight (kg)',
  estimated_volume: 'Estimated Volume',
  packing_needed: 'Packing Required?',
  insurance_needed: 'Insurance Required?',
  floor_from: 'Floor (Origin)',
  floor_to: 'Floor (Destination)',
  has_elevator_from: 'Lift at Origin?',
  has_elevator_to: 'Lift at Destination?',

  // === GENERIC FORM FIELDS ===
  service_description: 'Service Description',
  estimated_duration: 'Estimated Duration',
  budget_min: 'Minimum Budget',
  budget_max: 'Maximum Budget',
  budget_negotiable: 'Budget Negotiable',
  contact_name: 'Contact Name',
  contact_phone: 'Contact Phone',
  contact_method: 'Contact Method',
  availability: 'Availability',
  service_location: 'Service Area',
  service_category: 'Service Category',

  // === VEHICLE LISTING ===
  price_type: 'Price Type',
  year: 'Year',
  fuel_type: 'Fuel Type',
  transmission: 'Transmission',
  mileage: 'Mileage',
  engine_cc: 'Engine Size (cc)',
  color: 'Colour',
  body_type: 'Body Type',
  condition: 'Condition',
  has_damage_record: 'Damage Record',
  from_owner: 'From Private Seller',
  warranty: 'Warranty',

  // === PROPERTY ===
  listing_type: 'Listing Type',
  owner_type: 'Listing Owner',
  gross_area: 'Gross m²',
  net_area: 'Net m²',
  floor: 'Floor',
  total_floors: 'Total Floors',
  building_age: 'Building Age',
  bathroom_count: 'Number of Bathrooms',
  heating_type: 'Heating Type',
  balcony: 'Balcony',
  elevator: 'Lift',
  parking: 'Parking',
  furnished: 'Furnished',
  rent_period: 'Rent Period',
  deposit: 'Deposit',
  land_area: 'Plot Area',
  zoning_status: 'Planning Status',

  // === ADDITIONAL FIELDS ===
  accommodation: 'Accommodation',
  age_restriction: 'Age Limit',
  animal_type: 'Animal Type',
  area: 'Area',
  balcony_count: 'Number of Balconies',
  capacity: 'Capacity',
  category: 'Category',
  credit_eligible: 'Mortgage Eligible',
  damage_records: 'Damage Record',
  deed_status: 'Title Status',
  delivery: 'Delivery',
  dress_code: 'Dress Code',
  driver_license: 'Driving Licence',
  education: 'Education',
  end_date: 'End Date',
  event_date: 'Event Date',
  event_type: 'Event Type',
  experience: 'Experience',
  experience_years: 'Experience (Years)',
  fiber_internet: 'Fibre Internet',
  food: 'Food',
  gender: 'Gender',
  gross_area_display: 'Gross Area (m²)',
  has_ticket: 'Has Ticket?',
  hours: 'Working Hours',
  insurance: 'Insurance',
  intercom: 'Intercom',
  issue_type: 'Issue Type',
  job_type: 'Job Type',
  location_type: 'Location Type',
  machine_type: 'Machine Type',
  mileage_display: 'Mileage',
  military_status: 'Military Service',
  near_bus_stop: 'Near Bus Stop',
  near_hospital: 'Near Hospital',
  near_market: 'Near Supermarket',
  near_school: 'Near School',
  net_area_display: 'Net Area (m²)',
  on_main_road: 'On Main Road',
  organic: 'Organic',
  organizer_email: 'Organiser Email',
  organizer_name: 'Organiser Name',
  organizer_phone: 'Organiser Phone',
  position: 'Position',
  privatehealthcare: 'Private Health Insurance',
  product_category: 'Product Category',
  product_type: 'Product Type',
  quantity: 'Quantity',
  rental_income: 'Rental Income',
  rental_income_display: 'Rental Income',
  salary_max: 'Max Salary',
  salary_min: 'Min Salary',
  salary_type: 'Salary Type',
  sector: 'Sector',
  site_open_parking: 'Estate / Open Parking',
  steel_door: 'Steel Door',
  suitable_for: 'Suitable For',
  swap_eligible: 'Open to Swap',
  ticket_price: 'Ticket Price',
  total_floors_display: 'Total Floors',
  transport: 'Transport',
  tree_count_display: 'Number of Trees',
  unit: 'Unit',
  usage_status: 'Usage Status',
  venue: 'Venue',
  view: 'View',
  vitrin: 'Featured',
  vitrin_length: 'Window Length (m)',
  vitrin_length_display: 'Window Length (m)',
  wc_count: 'Number of Toilets',
  wc_inside: 'Indoor Toilet',
  year_display: 'Year',
};

export function getFieldLabel(key) {
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];
  // _min / _max suffix → derive "Min. {Base}" / "Max. {Base}"
  const rangeMatch = key && key.match(/^(.+?)_(min|max)$/);
  if (rangeMatch && FIELD_LABELS[rangeMatch[1]]) {
    const prefix = rangeMatch[2] === 'min' ? 'Min.' : 'Max.';
    return `${prefix} ${FIELD_LABELS[rangeMatch[1]]}`;
  }
  return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

/**
 * Build a key→label map from a form schema's fields/filters.
 * For composite fields (e.g. province_district), produces sub-key labels too.
 * @param {Object} schema - The form schema with fields or filters arrays
 * @returns {Object} Map of field key/name to label
 */
export function buildSchemaLabelMap(schema) {
  if (!schema) return {};
  const labelMap = {};
  const allFields = [
    ...(schema.filters || []),
    ...(schema.fields || []),
  ];
  for (const field of allFields) {
    const fieldKey = field.key || field.name;
    if (!fieldKey || !field.label) continue;
    labelMap[fieldKey] = field.label;
    // Composite field expansion: province_district writes 4 sub-keys to form_data.
    if ((field.type || '').toLowerCase() === 'province_district') {
      labelMap[`${fieldKey}_name`] = `${field.label} (County)`;
      labelMap[`${fieldKey}_district_name`] = `${field.label} (District)`;
      labelMap[`${fieldKey}_province_name`] = `${field.label} (County)`;
      labelMap[`${fieldKey}_province_district_name`] = `${field.label} (District)`;
    }
  }
  return labelMap;
}

/**
 * Should this form_data key be shown to the user?
 * - keys ending in `_id` → internal ID, hide
 * - keys ending in `_display` → UI-only helper, hide (real value is shown elsewhere)
 * - known internal keys → hide
 */
export function shouldHideDataKey(key, _allKeys = []) {
  if (!key || typeof key !== 'string') return true;
  if (key === 'schema_id' || key === 'schema_type' || key === 'form_version') return true;
  if (key.endsWith('_id')) return true;
  if (key.endsWith('_display')) return true;
  return false;
}

/**
 * Get field label with schema-aware resolution.
 * First checks the dynamic schema label map, then falls back to static FIELD_LABELS.
 * `_min` / `_max` suffixes derive `Min./Max. {BaseLabel}` from the known base label.
 * @param {string} key - The field key
 * @param {Object} schemaLabelMap - Optional map from buildSchemaLabelMap()
 * @returns {string} Human-readable label
 */
export function resolveFieldLabel(key, schemaLabelMap) {
  if (schemaLabelMap && schemaLabelMap[key]) return schemaLabelMap[key];
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];

  const rangeMatch = key.match(/^(.+?)_(min|max)$/);
  if (rangeMatch) {
    const baseKey = rangeMatch[1];
    const prefix = rangeMatch[2] === 'min' ? 'Min.' : 'Max.';
    const baseLabel =
      (schemaLabelMap && schemaLabelMap[baseKey]) ||
      FIELD_LABELS[baseKey];
    if (baseLabel) return `${prefix} ${baseLabel}`;
  }

  return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

export default FIELD_LABELS;
